import { TableHeaderClone } from "core/Controls/TableHeaderClone";
import { StickyElementPosition } from "core/Controls/StickyElementPosition";
import { View, ViewData } from "silver";

const html = `<div class="fixedHeaderTable">
					<div data-myon-name="fixedHeaderContainer" class="fixedHeaderTable_cloneContainer"></div>
					<div data-myon-name="tableContainer" class="fixedHeaderTable_tableContainer"></div>
				</div>`;

interface StickyHeaderTableView extends View<ViewData> {
	fixedHeaderContainer: HTMLDivElement;
	fixedHeader: HTMLDivElement;
	tableContainer: HTMLDivElement;
}

export class StickyHeaderTable {

	private view: StickyHeaderTableView;
	private clonedHeader: TableHeaderClone;
	private position: StickyElementPosition;

	private stuckToTop: boolean = false;
	private initialized: boolean = false;

	constructor(
		private table: HTMLTableElement,
		private stickyTopValue: number
	) {
		this.clonedHeader = new TableHeaderClone(table);
		this.view = new View<ViewData>(html, { }, { }) as StickyHeaderTableView;
		this.view.fixedHeaderContainer.appendChild(this.clonedHeader.element);
		this.clonedHeader.element.classList.add("fixedHeaderTable_cloneTable");
		this.position = new StickyElementPosition(this.view.element, this.stickyTop);
		this.position.onParentNodeScroll(() => this.handleStickinessUpdate(true));
		this.initialize();
	}

	public get element(): HTMLElement {
		return this.view.element;
	}

	public get stickyTop(): number {
		return this.stickyTopValue;
	}

	public set stickyTop(value: number) {
		this.stickyTopValue = value;
		this.resize();
	}

	public resize(): void {
		this.clonedHeader.resize();
		const height = this.clonedHeader.headerHeight as number;

		if (height > 0) {
			this.view.fixedHeaderContainer.style.height = `${height}px`;
			this.table.style.marginTop = `${-1 * height}`;
			this.initialized = true;
			this.view.element.classList.add("-initialized");
		}

		this.handleStickinessUpdate(true);
	}

	private handleStickinessUpdate(force: boolean = false): void {
		if (force) {
			this.position.recalculate(this.view.element, this.stickyTop);
		}
		if (!this.view.element.isConnected) {
			return;
		}

		const shouldStickToTop = this.position.topIsAboveViewport();
		if (shouldStickToTop != this.stuckToTop || force) {
			this.stuckToTop = shouldStickToTop;
			this.view.element.classList.toggle("-sticky", this.stuckToTop);
			if (this.stuckToTop) {
				this.table.style.marginTop = "0";
				this.view.fixedHeaderContainer.style.top = `${this.stickyTop}px`;
			}
			if (!this.stuckToTop) {
				this.view.fixedHeaderContainer.style.top = "";
				this.table.style.marginTop = `${-1 * (this.clonedHeader.headerHeight as number)}px`;
			}
		}

		const { width, left } = this.element.getBoundingClientRect();
		this.view.fixedHeaderContainer.style.width = `${width}px`;
		this.view.fixedHeaderContainer.style.left = this.stuckToTop ? `${left}px` : "";
		this.view.fixedHeaderContainer.scrollLeft = this.view.tableContainer.scrollLeft;
	}

	private initialize(): void {

		if (this.table.parentNode) {
			this.table.parentNode.insertBefore(this.view.element, this.table);
		}
		this.view.tableContainer.appendChild(this.table);
		window.addEventListener("resize", () => this.resize());
		window.addEventListener("scroll", () => {
			this.handleStickinessUpdate();
		});
		this.view.tableContainer.addEventListener("scroll", () => {
			this.handleStickinessUpdate();
			if (!this.initialized) {
				this.resize();
			}
		});

		this.resize();
	}
}
